/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import { default as OriginalRoute } from 'embercom/routes/apps/app/automation/workflows/edit';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type Transition from '@ember/routing/transition';
import type Store from '@ember-data/store';

export default class Route extends OriginalRoute {
  @service declare appService: AppService;
  @service declare contentEditorService: $TSFixMe;
  @service declare store: Store;
  controllerName = 'apps/app/automation/workflows/edit';

  beforeModel() {
    this.store.findAll('office-hours-schedule', this.appService.app?.id);
  }

  setupController(controller: any, model: any) {
    super.setupController(controller, model);
    let queryParams = this.router.currentRoute?.queryParams || {};
    this.contentEditorService.isFinEnabled = queryParams['fin'] === 'true';
    this.contentEditorService.isOpenInFinStandalone = true;
    this.setWorkflowOpenMode(controller, model);
  }

  resetController(controller: any, isExiting: any, _transition: any) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('returnPath', null);
    }

    controller.set('mode', null);
  }

  @action
  willTransition(transition: Transition & { isAborted: boolean }) {
    super.willTransition(...arguments);

    if (transition.isAborted) {
      return;
    }

    this.contentEditorService.isOpenInFinStandalone = false;
    this.contentEditorService.isFinEnabled = false;
  }

  setWorkflowOpenMode(controller: any, model: any) {
    let editMode = controller.mode === 'edit' || this.isInEditMode;
    let mode = !model.isLive || (editMode && model.isLive) ? 'edit' : 'view';
    controller.set('mode', mode);
  }

  get isInEditMode() {
    let queryParams = this.router.currentRoute?.queryParams || {};
    return queryParams['mode'] === 'edit';
  }
}
